export const apiUrl =
  process.env.REACT_APP_ENV === "production"
    ? process.env.REACT_APP_API_PRODUCTION_URL
    : process.env.REACT_APP_API_LOCAL_URL;
